import { gql } from '@apollo/client';

export const LIST_SEARCH_MERCHANTS_CSV = gql`
  query companies($input: ListSearchCompanyInput) {
    listSearchCompaniesCSV(input: $input) {
      csv
    }
  }
`;
